// extracted by mini-css-extract-plugin
module.exports = {"row":"PartnerBox_row__dMYce","item":"PartnerBox_item__3IEIU","itemNoShadow":"PartnerBox_itemNoShadow__2jKtb","img":"PartnerBox_img__3oYfJ"};